export const LINKS = {
    GITHUB: "https://github.com/Dinu-Senal/",
    LINKEDIN: "https://www.linkedin.com/in/dinu-senal/",
    INSTAGRAM: "https://www.instagram.com/dinu_senal/",
    SKYPE: "live:.cid.b7dd4bdb1e85f27f",
    PHONE: "0481958419",
    GMAIL: "dinusenal8@gmail.com",
    CV: "documents/Dinu Senal - CV.pdf",
    ECERT: "documents/Dinu Senal - eCertification - Computer Science Degree",
    IIT: "https://www.iit.ac.lk/",
    UOW: "https://www.westminster.ac.uk/",
    INFORMATES: "https://github.com/Informates",
    AVANTRIO: "https://avantrio.xyz/",
    VERSTEAD: "https://verstead.com/",
    MEDIUM: "https://medium.com/@dinusenal8",
    RMIT: "https://www.rmit.edu.au/",
}

export const HOME_PAGE = {
    INTRODUCTION: "I love to craft solid and scalable web applications with a fantastic user experience and a robust backend. I have more than 3 years of industrial experience as a software engineer. I'm meticulous about every phase of the development. I love to code with a team and share knowledge that benefits one another. I'm always looking to improve my skills and update my knowledge to the latest solutions and best practices, which enhances the speed and quality of the development process. Following are some of the key moments as a software engineer.",
    GRAD_INTRODUCTION: "I successfully completed the computer science degree at IIT (affiliated with the University of Westminster, UK)",
    FREELANCE_INTRODUCTION: "While following the computer science degree and after, I contributed to web app projects that are developed with a team of my university friends or by myself.",
    INTERN_INTRODUCTION: "I worked at Avantrio software company as a intern full-stack software engineer. Avantrio is affiliated with Verstead company, and I also contributed to a set of projects associated with Verstead.",
    ASSOCIATE_INTRODUCTION: "After my final year at the university, I started my software engineering career at Avantrio. To this day I commit to the web app project associated with Avantrio.",
    SOFTWARE_ENGINEER_INTRODUCTION: "The diverse projects that I contributed in has sharpened my analytical skills, allowing me to identify and address challenges efficiently. I have successfully balanced the need for innovation with the importance of maintaining software integrity, ensuring that the end products meet the highest standards of quality and functionality.",
    MEDIUM_ARTICLE_WRITER: "I write about topics that interest me for Medium.",
    INSTRUCTOR_INTRODUCTION: "I teach Python programming and Roblox, helping students understand coding principles. I regularly assess their progress and provide feedback. I maintain an engaging classroom environment and explain concepts clearly, making sure all skill levels are accommodated.",
    MASTER_INTRODUCTION: "Currently pursuing my Master's at RMIT University in Melbourne.",
}

export const TECH_STACK = {
    ONE: {
        name: "reactJs",
        number: 3
    }, 
    TWO: {
        name: "redux",
        number: 3
    },
    THREE: {
        name: "JavaScript",
        number: 3
    },
    FOUR: {
        name: "TypeScript",
        number: 1
    },
    FIVE: {
        name: "NextJs",
        number: 4
    },
    SIX: {
        name: "React Native",
        number: 1
    },
    SEVEN: {
        name: "HTML",
        number: 6
    },
    EIGHT: {
        name: "CSS",
        number: 6
    },
    NINE: {
        name: "SCSS",
        number: 3
    },
    TEN: {
        name: "BootsTrap",
        number: 3
    },
    ELEVEN: {
        name: "MUI",
        number: 6
    },
    TWELVE: {
        name: "JQuery",
        number: 1
    },
    THIRTEEN: {
        name: "Django",
        number: 2
    },
    FOURTEEN: {
        name: "Python",
        number: 3
    },
    FIFTEEN: {
        name: "Blazor",
        number: 1
    },
    SIXTEEN: {
        name: "C#",
        number: 1
    },
    SEVENTEEN: {
        name: "Postgres",
        number: 1
    },
    EIGHTEEN: {
        name: "MYSQL",
        number: 2
    },
    NINETEEN: {
        name: "Solana",
        number: 6
    },
    TWENTY: {
        name: "Rust",
        number: 6
    },
    TWENTY_ONE: {
        name: "AdobeXD",
        number: 1
    },
    TWENTY_TWO: {
        name: "Figma",
        number: 1
    },
}

export const PROJECTS = {
    PROJECT_ONE: { 
        name: "Kasi Warehouse",
        desc: "The app aims to simplify the process of ordering and delivering through the app, thereby reducing the hassles of manual order tracking and management in the order process.",
        tech: "React Native, Redux, Bootstrap",
        date: "2023-06-01 | Present",
        association: "Avantrio"
    },
    PROJECT_TWO: { 
        name: "Tharanga Timbers",
        desc: "A web application that assists the owner of Tharanga Timbers in digitalizing the sawmill process and customer relations.",
        tech: "React, Redux, Bootstrap, SCSS, AdobeXD, Asana",
        date: "2023-08-12 | Present",
        project_kind: "Freelance Project"
    },
    PROJECT_THREE: { 
        name: "Geologix",
        desc: "A web application that provides mining engineers to log the mining procedures.",
        tech: "React, Redux, Bootstrap, SCSS, AdobeXD, Asana",
        date: "2022-11-23 | 2023-06-17",
        project_kind: "Freelance Project"
    },
    PROJECT_FOUR: { 
        name: "WalletApp",
        desc: "A budget manager and spending tracker mobile app that'll help user to manage their personal finances with ease.",
        tech: "React Native, Redux, Bootstrap",
        date: "2023-05-03 | 2023-06-27",
        association: "Avantrio"
    },
    PROJECT_FIVE: { 
        name: "ThreatIt",
        desc: "TreatIt is a UK-based platform that provides online pain treatment programs with the help of leading medical specialists in the industry.",
        tech: "React, Redux, Bootstrap, Figma",
        date: "2022-11-08 | 2023-04-17",
        association: "Avantrio"
    },
    PROJECT_SIX: { 
        name: "HighRoad",
        desc: "Cannabis delivery platform is a US-based startup that provides e-commerce visibility and solves the last-mile problem for medical cannabis dispensaries.",
        tech: "ReactJs, Redux Tool Kit",
        date: "2022-06-01 | 2023-05-11",
        link: {
            name: "Web Site",
            url: "https://www.highroaddelivery.com/"
        },
        association: "Verstead x Avantrio"
    },
    PROJECT_SEVEN: { 
        name: "Actium",
        desc: "A decentralized vessel maintenance system implemented on Solana blockchain.",
        tech: "Rust, TypeScript, React, SCSS, AdobeXD, Asana",
        date: "2021-07-10 | 2022-02-14",
        link: {
            name: "Show Git",
            url: "https://github.com/Dinu-Senal/actium"
        }
    },
    PROJECT_EIGHT: { 
        name: "Solarcrm",
        desc: "A customer relationship management webapp system for Austral solar cooperation.",
        tech: "React, Redux, RTK Query, Django Rest",
        date: "2021-07-10 | 2022-02-14",
        association: "Avantrio"
    },
    PROJECT_NINE: { 
        name: "Osiris",
        desc: "A project management webapp for multiple companies.",
        tech: "Blazor, C#",
        date: "2021-11-03 | 2022-01-06",
        link: {
            name: "Show Git",
            url: "https://github.com/Dinu-Senal/osiris"
        }
    },
    PROJECT_TEN: { 
        name: "Intrview",
        desc: "A webapp that visualizes interviewee performance according to interviewer's data.",
        tech: "React, Django",
        date: "2021-06-17 | 2021-07-04",
        association: "Avantrio"
    },
    PROJECT_ELEVEN: { 
        name: "Taxien",
        desc: "A webapp with various filtering options that assist the user in discovering apartments.",
        tech: "NextJs, RTK Query, Django",
        date: "2021-05-19 | 2021-08-02",
        association: "Avantrio"
    },
    PROJECT_TWELVE: { 
        name: "Aceplan",
        desc: "A vehicle delivery system that predicts the delivery route and time.",
        tech: "React, Redux, Django Rest",
        date: "2020-11-15 | 2021-03-04",
        association: "Avantrio"
    },
    PROJECT_THIRTEEN: { 
        name: "SOLARCRM V2",
        desc: "The version two of the Solar CRM that consisting a new boilerplate and extends into TypeScript and NextJS",
        tech: "TypeScript, NextJs, Django",
        date: "2021-08-03 | 2021-09-18",
        association: "Avantrio"
    },
    PROJECT_FOURTEEN: { 
        name: "Speed Estimator",
        desc: "A system that suggests overall expense for items needed for construction.",
        tech: "Django",
        date: "2020-08-21 | 2020-09-14",
        association: "Verstead"
    },
    PROJECT_FIFTEEN: { 
        name: "Exclusive Realtors",
        desc: "A web application that advertises real-estate properties.",
        tech: "ReactJs",
        date: "2021-04-03 | 2021-05-22",
        association: "Informates"
    },
}